import { Modal } from 'antd';
import React, { useRef, useState } from 'react';
import styled from "@emotion/styled"
import { GatsbyImage } from "gatsby-plugin-image"

const PopupWrapper = styled.div`

`

const PopupVideoWrapper = styled.div`
  position: relative;
`

const PopupVideo = styled.video`
  display: block;
  width: 100%;
  height: auto;
`

const UnmuteButton = styled.button`
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 8px 14px;
  border: 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-family: "Kanit", sans-serif;
  font-size: 15px;
  line-height: 1.2;
  cursor: pointer;
`

const Popup = ({ImagePopup, VideoPopup, UnmuteText = "🔇 แตะเพื่อเปิดเสียง"}) => {
  const [modal2Open, setModal2Open] = useState(true);
  const [videoMuted, setVideoMuted] = useState(true);
  const videoRef = useRef(null);

  // iOS/iPadOS Safari has no mute toggle in the native controls,
  // so unmute from a user tap on our own button.
  const handleUnmute = () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = false;
    video.volume = 1;
    const playPromise = video.play();
    if (playPromise && playPromise.catch) playPromise.catch(() => {});
    setVideoMuted(false);
  };

  return (
    <PopupWrapper open={modal2Open}>
      <Modal
        centered
        destroyOnClose
        className={VideoPopup ? "popup-video" : undefined}
        visible={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
      >
        {VideoPopup ? (
          <PopupVideoWrapper>
            <PopupVideo
              ref={videoRef}
              src={VideoPopup}
              autoPlay
              muted
              playsInline
              controls
              onVolumeChange={e => setVideoMuted(e.currentTarget.muted)}
            />
            {videoMuted && (
              <UnmuteButton type="button" onClick={handleUnmute}>
                {UnmuteText}
              </UnmuteButton>
            )}
          </PopupVideoWrapper>
        ) : (
          <GatsbyImage image={ImagePopup} alt="" />
        )}
      </Modal>
    </PopupWrapper>
  );
};

export default Popup;
